import { render, staticRenderFns } from "./MachineItems.vue?vue&type=template&id=36251b4f"
import script from "./MachineItems.vue?vue&type=script&lang=js"
export * from "./MachineItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports